module.exports = __webpack_public_path__ + "static/media/intro-photowall-19.afb4299e.jpg";